// @flow
import React, { useMemo, useState } from 'react';
import { fetcher } from '../shared/utils/Api';


const defaultParams = {
  timezone: [],
  updateTimezone: (t) => t
};

export const AppContent: any = React.createContext(defaultParams);

export const useAppContext: any = () => React.useContext(AppContent);

const setLocalTimezone: any = (tz) => {
  const old = JSON.parse(window.localStorage.getItem('subscriber-store') as any);
  window.localStorage.setItem(
    'subscriber-store',
    JSON.stringify({
      ...old,
      tz,
      updatedDate: Date.now()
    })
  );
};

export const AppProvider = ({ children }) => {
  const [timezone, setTimezone] = useState();
  const [filteredComponentsList, setFilteredComponentsList] = useState([]);
  const setTimezoneStore = async (tz, accountId) => {
    setTimezone(tz);
    const user = !!window.localStorage.getItem('subscriber-token');
    if (user) {
      const store = JSON.parse(window.localStorage.getItem('subscriber-store') as any);
      if (store && store.tz === tz) {
        return false;
      }
      const URL = `/public-update-subscribers/${
        store && store.id
      }/?account_id=${accountId}`;
      await fetcher(URL, {
        method: 'PATCH',
        payload: {
          timezone: tz
        },
        auth: true
      });
    }
    setLocalTimezone(tz);
  };

  const initialValue = useMemo(
    () => ({
      timezone,
      setTimezone,
      setTimezoneStore,
      filteredComponentsList,
      setFilteredComponentsList
    }),
    [timezone, setTimezone, filteredComponentsList]
  );

  return (
    <AppContent.Provider value={initialValue}>{children}</AppContent.Provider>
  );
};
